import { formatMetric } from '../panelConfig';

/** Top productos del período por revenue (ecommerce). Tabla estética reporte;
 *  el panel/título lo pone EcomPanel (va dentro del scope .ecp). */
export default function TopSkusTable({ skus }) {
  return (
    <table className="ecp-table">
      <thead>
        <tr>
          <th>Producto</th>
          <th>Revenue</th>
          <th>Vendidas</th>
        </tr>
      </thead>
      <tbody>
        {skus.map((s) => (
          <tr key={s.sku}>
            <td>
              {s.product_name || s.sku}
              {s.product_name && <span className="sku">{s.sku}</span>}
            </td>
            <td>{formatMetric(s.revenue, 'currency')}</td>
            <td>{formatMetric(s.quantity, 'number')}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
